<template>
	<div class="dynamic-header-wrapper">
		<div class="dynamic-header bg-base-100" :style="styling">
			<div ref="dh">
				<template v-if="route.name == 'Admin'"><AdminHeader /></template>

				<template v-else-if="route.name == 'AuthUserProfile'"><AuthUserProfileHeader /></template>
				<template v-else-if="route.name == 'Module'"><ModulesHeader /></template>
				<template v-else-if="route.name == 'Modules'"><ModulesHeader /></template>
				<template v-else-if="route.name == 'Hub'"><HubHeader /></template>
				<template v-else-if="route.name == 'Hubs'"><HubsHeader /></template>
				<template v-else-if="route.name == 'Graphs'"><GraphHeader /></template>

				<template v-else-if="route.name == 'Projects'"><ProjectListHeader /></template>
				<template v-else-if="route.name == 'Project'"><ProjectHeader /></template>

				<template v-else-if="route.name == 'Locations'"><LocationsHeader /></template>
				<template v-else-if="route.name == 'Location'"><LocationHeader /></template>

				<template v-else-if="route.name == 'Inventory'"><InventoryHeader /></template>
				<template v-else-if="route.name == 'Users'"><UsersHeader /></template>

				<!-- name: 'Alerts',
name: 'Home',
name: 'About',
name: 'SignIn',
name: 'Users',
name: 'AuthUserProfile',
name: 'Projects',
name: 'Project',
name: 'Yocto',
name: 'Locations',
name: 'Location',
name: 'Hubs',
name: 'Hub',
name: 'Comapps',
name: 'AlertMatrixByUser',
name: 'AlertMatrixForGraphs',
name: 'Inventory',
name: 'Comapp',
name: 'Module',
name: 'Chart',
name: 'NewGraph',
name: 'IPCalls',
name: 'Admin',
name: 'ChangeLogs', -->

				<span v-else>
					<div class="card bg-base-100 mb-4 shadow">
						<div class="card-body"></div>
					</div>
				</span>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { useRoute } from 'vue-router'
	import { computed, ref, Transition, useTemplateRef, watch } from 'vue'
	import LocationHeader from '@/features/locations/LocationHeader.vue'
	import ProjectHeader from '@/features/projects/ProjectHeader.vue'
	import LocationsHeader from '@/features/locations/LocationsHeader.vue'
	import { useElementSize } from '@vueuse/core'
	import { useBaseStore } from '@/stores/base.store'
	import AdminHeader from '@/features/admin/AdminHeader.vue'
	import AuthUserProfileHeader from '@/features/auth/AuthUserProfileHeader.vue'
	import ProjectListHeader from '@/features/projects/ProjectListHeader.vue'
	import ModulesHeader from '@/features/moduls/ModulesHeader.vue'
	import HubHeader from '@/features/hubs/HubHeader.vue'
	import HubsHeader from '@/features/hubs/HubsHeader.vue'
	import GraphHeader from '@/features/chart/CustomGraphSettings/GraphHeader.vue'
	import InventoryHeader from '@/features/inventory/components/InventoryHeader.vue'
	import UsersHeader from '@/features/users/UsersHeader.vue'

	const route = useRoute()
	const baseStore = useBaseStore()
	const el = useTemplateRef('dh')
	const { width, height } = useElementSize(el)
	const hideHeader = computed(() => !baseStore.getActiveIds._showHeader)
	const styling = computed(() => ({
		height: `${hideHeader.value ? 0 : height.value}px`,
		opacity: `${hideHeader.value ? 0 : 1}`,
	}))
</script>

<style scoped>
	@reference '@/styles/tailwind.css';
	.dynamic-header-wrapper {
		@apply z-100;
	}

	.dynamic-header {
		@apply opacity-100;
		@apply shadow-lg;
		@apply overflow-hidden;
		@apply transition-all duration-200 ease-in-out;
	}
</style>
